<template>
    <header class="p-5 pb-0 m-0">
        <a href="/">
            <img src="@/assets/images/kalamaio-logo-full-light-72.png"/>
        </a>
    </header>
</template>
<script>
export default {
    name: 'LoginHeader'
};
</script>
